export class CartItem {
    constructor({ item, quantity }) {
        this.item = item;
        this.quantity = quantity;
    }
}
